import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { getImages } from '../const'
import { VehicleContext } from '../Context/VehicleContext'
import ActionButtons from './ActionButtons'
import SearchComponent from './SearchComponent'
const inventoryMenuList = [
    {
        title: 'Artura',
        image: 'model-image1.webp',
        link: ''
    },
    {
        title: 'Artura Spider',
        image: 'Artura_Spider.png',
        link: ''
    },
    {
        title: 'GTS',
        image: 'GTS.png',
        link: ''
    },
    {
        title: '750S',
        image: '750s_Coupe.png',
        link: ''
    },
    {
        title: '750S Spider',
        image: '750s_Spider.png',
        link: ''
    },
    {
        title: '750S Coupe',
        image: '750s_Coupe.png',
        link: ''
    },
    {
        title: '570S',
        image: 'model-image7.webp',
        link: ''
    },
    {
        title: '570S Spider',
        image: 'model-image8.webp',
        link: ''
    },
    {
        title: '600LT',
        image: 'model-image9.webp',
        link: ''
    },
    {
        title: '600LT Spider',
        image: 'model-image10.webp',
        link: ''
    },
]
const Header = () => {
    const { getVehicleData, vehicleData,filteredVehicleData, searchText, setSearchText, vehicleModels } = useContext(VehicleContext);

    useEffect(() => {
        if (!vehicleData) getVehicleData();
    }, []);

    const [isMob, setisMob] = useState(false);
    const onChangeBodyClass = (value) => {
        setisMob(value);
        value
            ? document.body.classList.add('overflow-active')
            : document.body.removeAttribute('class');
    };
    const [openSubMenu, setOpenSubMenu] = useState(false)
    const handleSubMenu = (menu) => {
        setOpenSubMenu((prevMenu) => (prevMenu === menu ? null : menu));
        // console.log("menu", menu)
    }
    const hoverHandleSubMenu = (menu) => {
        if (window.innerWidth > 1200) {
            setOpenSubMenu((prevMenu) => (prevMenu === menu ? null : menu));
            // console.log("MobMenu", menu);
        }
    }
    const closeMenu = () => {
        setisMob(false);
        setOpenSubMenu(false);
        document.body.classList.remove('overflow-active');
    }
    // Search Dropdown
    const [openDropdown, setOpenDropdown] = useState(null);
    const toggleDropdown = (type) => {
        setOpenDropdown(prev => (prev === type ? null : type));
    };
    const wrapperRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setOpenDropdown(null); // ← this closes the dropdown
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    
    const openVDP = (vdp_url) => {
        window.location.href = vdp_url;
    }
    return (
        <>
            <div className='header-main-wrap'>
                <header className="header-wrap">
                    <div className='container'>
                        <div className='d-flex align-items-center justify-content-between header-flex'>
                            <div className='main-logo'>
                                <Link to="/">
                                    <img src={getImages('mclaren-orlando-logo-white.png')} />
                                </Link>
                            </div>
                            <div className='header-right d-flex align-items-center'>
                                <div className='d-flex align-items-center'>
                                    <div className={`main-menu ${isMob ? 'active' : ''}`}>
                                        <ul className='d-flex align-items-center'>
                                            <li className={`sub-menu ${openSubMenu === 'models' ? 'open' : ''}`}
                                                onMouseEnter={() => hoverHandleSubMenu('models')}
                                                onMouseLeave={() => hoverHandleSubMenu(null)}
                                            >
                                                <NavLink to="/inventory" className='d-none d-xl-block'>Models <span className='menu-arrow-icon'></span></NavLink>
                                                <a href="#" className='d-xl-none' onClick={() => handleSubMenu('models')}>Models <span className='menu-arrow-icon'></span></a>
                                                <ul className='sub-mega-menu w-1330 service-m-menu'>
                                                    <li className='w-100'>
                                                        <div className='row'>
                                                            {inventoryMenuList.filter((item) => vehicleModels.includes(item.title)).map((item, index) =>
                                                                <div className='col-xl-3 col-12 my-2' key={index}>
                                                                    <Link to={'/inventory?model=' + item.title} className='subm-col' onClick={closeMenu}>
                                                                        <div className='xs-title font-1-2em'>{item.title}</div>
                                                                        <div className='text-start my-3'>
                                                                            <img src={getImages(item.image)} alt={item.title} />
                                                                        </div>
                                                                        <div>
                                                                            <span className='sub-sm-btn'>VIEW</span>
                                                                        </div>
                                                                    </Link>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li className={`sub-menu position-relative ${openSubMenu === 'new' ? 'open' : ''}`}
                                                onMouseEnter={() => hoverHandleSubMenu('new')}
                                                onMouseLeave={() => hoverHandleSubMenu(null)}
                                            >
                                                <Link to="/inventory/new" className='d-none d-xl-block'>New <span className='menu-arrow-icon'></span></Link>
                                                <a href="#" className='d-xl-none' onClick={() => handleSubMenu('new')}>New <span className='menu-arrow-icon'></span></a>
                                                <ul className='sub-menu-box'>
                                                    <li className='w-100'>
                                                        <NavLink to="/inventory/new" onClick={closeMenu}>New Inventory</NavLink>
                                                    </li>
                                                    {filteredVehicleData && filteredVehicleData.some(item => item.inventory_manage.lease_special) && <li className='w-100'>
                                                        <NavLink to="/lease-specials" onClick={closeMenu}>New Specials</NavLink>
                                                    </li>}
                                                    <li className='w-100'>
                                                        <NavLink to="/sell-or-trade" onClick={closeMenu}>Sell Us Your Car</NavLink>
                                                    </li>
                                                    {filteredVehicleData && filteredVehicleData.some(item => item.inventory_manage.lease_special) && <li className='w-100'>
                                                        <NavLink to="/lease-return" onClick={closeMenu}>McLaren Lease Return</NavLink>
                                                    </li>}
                                                </ul>
                                            </li>
                                            <li className={`sub-menu position-relative ${openSubMenu === 'pre-owned' ? 'open' : ''}`}
                                                onMouseEnter={() => hoverHandleSubMenu('pre-owned')}
                                                onMouseLeave={() => hoverHandleSubMenu(null)}
                                            >
                                                <Link to="/inventory/used" className='d-none d-xl-block' >Pre-Owned <span className='menu-arrow-icon'></span></Link>
                                                <a href="#" className='d-xl-none' onClick={() => handleSubMenu('pre-owned')}>Pre-Owned <span className='menu-arrow-icon'></span></a>
                                                <ul className='sub-menu-box'>
                                                    <li className='w-100'>
                                                        <NavLink to="/inventory/used" onClick={closeMenu}>Pre-Owned Inventory</NavLink>
                                                    </li>
                                                    <li className='w-100'>
                                                        <NavLink to="/inventory/certified-used" onClick={closeMenu}>Certified Pre-Owned</NavLink>
                                                    </li>
                                                    {/*<li className='w-100'>
                                                        <NavLink to="/inventory/used" onClick={closeMenu}>Pre-Owned Specials</NavLink>
                                                    </li>
                                                    <li className='w-100'>
                                                        <a href="#" onClick={closeMenu}>Sold Inventory</a>
                                                    </li>
                                                    <li className='w-100'>
                                                        <a href="#" onClick={closeMenu}>Sell Us Your Car</a>
                                                    </li>*/}
                                                </ul>
                                            </li>
                                            {/* <li>
                                                <a href='#' onClick={closeMenu}>Instant Appraisal</a>
                                            </li> */}
                                            <li className={`sub-menu position-relative ${openSubMenu === 'finance' ? 'open' : ''}`}
                                                onMouseEnter={() => hoverHandleSubMenu('finance')}
                                                onMouseLeave={() => hoverHandleSubMenu(null)}
                                            >
                                                <NavLink to="/finance-calculator" className='d-none d-xl-block'>Finance <span className='menu-arrow-icon'></span></NavLink>
                                                <a href="#" className='d-xl-none' onClick={() => handleSubMenu('finance')}>Finance <span className='menu-arrow-icon'></span></a>
                                                <ul className='sub-menu-box'>
                                                    <li className='w-100'>
                                                        <Link to="/finance-calculator" state={{ openModal: true }} onClick={closeMenu}>Finance Application</Link>
                                                    </li>
                                                    {/*<li className='w-100'>
                                                        <NavLink to="/consignment-agreement" onClick={closeMenu}>Consignment</NavLink>
                                                    </li>*/}
                                                    <li className='w-100'>
                                                        <NavLink to="/finance-calculator" state={{ scrollCalculator: true }} onClick={closeMenu}>Finance Calculator</NavLink>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li className={`sub-menu position-relative ${openSubMenu === 'service' ? 'open' : ''}`}
                                                onMouseEnter={() => hoverHandleSubMenu('service')}
                                                onMouseLeave={() => hoverHandleSubMenu(null)}
                                            >
                                                <NavLink to="/service" className='d-none d-xl-block' >Service <span className='menu-arrow-icon'></span></NavLink>
                                                <a href="#" className='d-xl-none' onClick={() => handleSubMenu('service')}>Service <span className='menu-arrow-icon'></span></a>
                                                <ul className='sub-menu-box'>
                                                    <li className='w-100'>
                                                        <NavLink to="/service" state={{ openRequestModal: true }} onClick={closeMenu}>Request An Appointment</NavLink>
                                                    </li>
                                                    <li className='w-100'>
                                                        <NavLink to="/roadside-assistance" onClick={closeMenu}>Roadside Assistance</NavLink>
                                                    </li>
                                                    <li className='w-100'>
                                                        <NavLink to="/lease-return" onClick={closeMenu}>McLaren Lease Return</NavLink>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                <NavLink to="/order-parts" onClick={closeMenu}>Parts</NavLink>
                                            </li>
                                            {/* <li>
                                                <NavLink to="/about-staff" onClick={closeMenu}>About Us</NavLink>
                                            </li> */}
                                            <li>
                                                <NavLink to="/about-staff" onClick={closeMenu}>About Us</NavLink>
                                            </li>
                                            {/*<li className={`sub-menu position-relative ${openSubMenu === 'aboutus' ? 'open' : ''}`}
                                                onMouseEnter={() => hoverHandleSubMenu('aboutus')}
                                                onMouseLeave={() => hoverHandleSubMenu(null)}
                                            >
                                                <NavLink to="/about-staff" className='d-none d-xl-block' >About Us <span className='menu-arrow-icon'></span></NavLink>
                                                <a href="#" className='d-xl-none' onClick={() => handleSubMenu('aboutus')}>About Us <span className='menu-arrow-icon'></span></a>
                                                <ul className='sub-menu-box about-smb'>
                                                    <li className='w-100'>
                                                        <NavLink to="/about-staff" onClick={closeMenu}>About Us</NavLink>
                                                    </li>
                                                    <li className='w-100'>
                                                        <NavLink to="/blog" onClick={closeMenu}>Blog</NavLink>
                                                    </li>
                                                </ul>
                                            </li>*/}
                                            <li>
                                                <NavLink to="/contact" onClick={closeMenu}>Contact</NavLink>
                                            </li>
                                        </ul>
                                    </div>
                                    <ActionButtons
                                        openDropdown={openDropdown}
                                        wrapperRef={wrapperRef}
                                        toggleDropdown={toggleDropdown}
                                    />
                                </div>
                                <div className={`overflow-bg ${isMob ? 'active' : ''
                                    }`} onClick={() => onChangeBodyClass(!isMob)}></div>
                                <div
                                    className={`mobile-inner-header ${isMob ? 'active' : ''}`}
                                    onClick={() => onChangeBodyClass(!isMob)}
                                >
                                    <div
                                        className={`mobile-inner-header-icon mobile-inner-header-icon-out ${isMob ? 'active' : ''
                                            }`}
                                    >
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
            </div>
            {openDropdown === 'search' && (
                <section className='head-search-block' ref={wrapperRef}>
                    <div className='container'>
                        {/* <input type='text' className='form-control' /> */}
                        <SearchComponent
                            filteredVehicleData={filteredVehicleData}
                            searchText={searchText}
                            setSearchText={setSearchText}
                            openVDP={openVDP}
                        />
                    </div>
                </section>
            )}
        </>
    )
}

export default Header